interface Props {
  title: string;
  imageUrl: string;
  onClose: () => void;
}

// Proof documents are always images (see OFFER_PHOTO_MIME_TYPES on the
// upload path), so a plain <img> is enough — no PDF/document viewer needed.
export default function ProofModal({ title, imageUrl, onClose }: Props) {
  return (
    <div
      className="modal-backdrop"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="proof-modal">
        <div className="proof-modal-header">
          <div className="modal-title">{title}</div>
          <button className="btn btn-ghost btn-sm" onClick={onClose}>
            Fermer
          </button>
        </div>
        <img src={imageUrl} alt={title} className="proof-modal-image" />
      </div>
    </div>
  );
}
